class InfiniteText extends HTMLElement {
    connectedCallback() {
        const elements = this.querySelectorAll('.banner-slide-items');
        const container = this.querySelector('.banner-slide-content');

        if (elements && container) {
        elements.forEach(function (element) {
            for (let i = 0; i < 2; i++) {
            const clonedElement = element.cloneNode(true);
            container.appendChild(clonedElement);
            }
        });
        }
    }
}

customElements.define('infinite-text', InfiniteText);